import { useTranslation } from 'react-i18next';
import { Affix, Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTER } from '../../../../constants/router';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

export default function Tab8({ dcDpo, editMode, isNoPermission, dataFlowInfo }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { businessProcessId } = useParams();

    return (
        <div className="grid grid-cols-3">
          <div className="col-span-3 text-right mt-2 mb-2">
                <Affix offsetTop={60}>
                    <Button
                        hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                        type="primary"
                        style={{ padding: '0px 30px' }}
                        onClick={() => {
                            navigate(
                                `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=7`
                            );
                        }}
                        size="large"
                        ghost
                    >
                        {t('common.Edit')}
                    </Button>
                </Affix>
            </div>

            <div
                className="col-span-2 p-4 mb-4"
                style={{ backgroundColor: '#F4F6FC' }}
            >
                <span className="text-lg font-semibold text-purple">
                    {t('dcdpo.DataController')}
                </span>
                <p className="whitespace-pre-wrap">{dcDpo?.nameTh || '-'}</p>
            </div>

            <div
                className="col-span-2 p-4 mb-4"
                style={{ backgroundColor: '#F4F6FC' }}
            >
                <span className="text-lg font-semibold text-purple">
                    {t('dcdpo.Address')}
                </span>
                <p className="whitespace-pre-wrap">{dcDpo?.addressTh || '-'}</p>
            </div>

            <div
                className="col-span-2 p-4 mb-4"
                style={{ backgroundColor: '#F4F6FC' }}
            >
                <span className="text-lg font-semibold text-purple">
                    {t('dcdpo.Contact')}
                </span>
                <p className="whitespace-pre-wrap">
                    {dcDpo?.contractTh || '-'}
                </p>
            </div>
        </div>
    );
}
